export enum AtsDateUnit {
	Second = 'Second',
	Minute = 'Minute',
	Hour = 'Hour',
	Day = 'Day',
	Month = 'Month',
	Year = 'Year',
}
